module.exports = __webpack_public_path__ + "img/ИФ-1(А)-033.7e67add8.png";